module.exports = __webpack_public_path__ + "img/rf1.a0b93b9b.png";